var module = angular.module('octopusApp.projects');


module.controller('ProjectVariablesAllController', function ($scope, $timeout, pageTitle, busy, projectState, octopusRepository,
                                                             $q, $uibModal, scopeValuesToScopeOptionsConverter) {
    var isLoading = $scope.isLoading = busy.create();
    var projectId = projectState.projectId;
    $scope.isSaving = busy.create();

    var stateOk = {icon: "check", class: "text-success", title: "A value is set for this variable"};

    function init() {
        isLoading.promise(
            loadProject()
                .then(getAndTransformVariablesAndTemplates)
            .then(function (result) {

                $scope.variableEditorOptions = {
                    variableSet: result,
                    scopeOptions: scopeValuesToScopeOptionsConverter(result.ScopeValues),
                    canEdit: false,
                    showSourceColumn: true,
                    disableContextMenu: true
                };

                $timeout(function () {
                    $scope.showVariableEditor = true;
                }, 100);

            })
    );
    }

    function loadProject() {
        return projectState.load()
        .then(function (project) {
            pageTitle("All " + project.Name + " variables");
            $scope.project = project;
            return project;
        });
    }

    function getAndTransformVariablesAndTemplates(project) {

        var projectVariablesSetP = octopusRepository.Variables.get(project.VariableSetId);
        var libraryP = getLibrarySetVariablesAndTemplates(project);
        var tenantsP = octopusRepository.Tenants ? octopusRepository.Tenants.all({projectId: project.Id}) : $q.resolve([]);
        var tenantVariablesP = octopusRepository.TenantVariables ? octopusRepository.TenantVariables.all({projectId: project.Id}) : $q.resolve([]);
        return $q.all([projectVariablesSetP, libraryP, tenantsP, tenantVariablesP])
        .then(function (results) {
            var projectVariableSet = results[0];
            var library = results[1];
            var tenants = results[2];
            var tenantVariables = toHash(results[3], "TenantId");

            var tenantProjectTemplateVariables = mapProjectTemplateVariables(project, tenants, tenantVariables);
            var tenantLibrarySetTemplateVariables = mapLibraryTemplateVariables(library.templates, tenants, tenantVariables);

            var projectVariables = mapVariableSets(projectVariableSet, "/projects/" + project.Slug + "/variables", project.Name);
            var scopeValues = _.extend(
                {Tenants: tenants},
                library.scopeValues,
                projectVariableSet.ScopeValues
            );

            return {
                ScopeValues: scopeValues,
                Variables: projectVariables
                    .concat(library.variables)
                    .concat(tenantProjectTemplateVariables)
                    .concat(tenantLibrarySetTemplateVariables)
            };
        });
    }

    function mapVariableSets(variableSet, sourceLink, sourceName) {
        return variableSet.Variables.map(function (variable) {
            return _.extend({
                State: stateOk,
                Source: {link: sourceLink, name: sourceName}
            }, variable);
        });
    }

    var getLibrarySetVariablesAndTemplates = function (project) {
        var mapLibrarySets = function (libraryVariableSets) {
            $scope.libraryVariableSetCount = 0;
            var variablePromises = libraryVariableSets.map(function (libraryVariableSet) {

                if(libraryVariableSet.ContentType === 'Variables') {
                    $scope.libraryVariableSetCount++;
                }

                return octopusRepository.Variables.get(libraryVariableSet.VariableSetId)
                    .then(function (variableSet) {
                        return {
                            scopeValues: variableSet.scopeValues,
                            variables: mapVariableSets(variableSet, "/library/variables/" + libraryVariableSet.Id, libraryVariableSet.Name)
                        };
                    });
            });



            var templates = _.pluck(libraryVariableSets, "Templates");

            return $q.all(variablePromises)
                .then(function (results) {
                    return {
                        templates: _.flatten(templates),
                        variables: _.flatten(_.pluck(results, "variables")),
                        scopeValues: results.reduce(function (a, b) {
                            return _.extend(a, b);
                        }, {})
                    };
                });
        };
        var loadingPromise = octopusRepository.LibraryVariableSets.all({ids: project.IncludedLibraryVariableSetIds});
        return loadingPromise.then(mapLibrarySets);
    };

    function mapProjectTemplateVariables(project, tenants, tenantVariables) {
        var getTenantsValue = function (tenant, template, environmentId) {
            var variablesForTenant = tenantVariables[tenant.Id];
            if (!variablesForTenant ||
                !variablesForTenant.ProjectVariables[project.Id] ||
                !variablesForTenant.ProjectVariables[project.Id].Variables[environmentId]) {
                return;
            }
            return variablesForTenant.ProjectVariables[project.Id].Variables[environmentId][template.Id];
        };

        var results = project.Templates.map(function (template) {
            return tenants.map(function (tenant) {
                var projectEnvironments = tenant.ProjectEnvironments[project.Id] || [];

                return projectEnvironments.map(function (environmentId) {
                    var value = getTenantsValue(tenant, template, environmentId)
                        || template.DefaultValue;

                    return {
                        State: value ? stateOk : {
                            icon: "warning",
                            class: "text-warning",
                            title: "This variable is missing for this tenant and environment"
                        },
                        Name: template.Name,
                        Id: template.Id + tenant.Id + environmentId,
                        Value: value,
                        IsSensitive: isSensitive(template, value),
                        Scope: {Tenant: [tenant.Id], Environment: [environmentId]},
                        Source: {link: "/tenants/" + tenant.Id + "/variables/projects", name: tenant.Name}
                    };
                });
            });
        });
        return _.flatten(results);
    }

    function mapLibraryTemplateVariables(libraryTemplates, tenants, tenantVariables) {
        if (!libraryTemplates) {
            return [];
        }

        var getTenantsValue = function (tenant, template) {
            var variablesForTenant = tenantVariables[tenant.Id];
            if (!variablesForTenant){
                return null;
            }

            for (var libVsId in variablesForTenant.LibraryVariables) {
                if (Object.keys(variablesForTenant.LibraryVariables[libVsId].Variables).indexOf(template.Id) !== -1) {
                    return variablesForTenant.LibraryVariables[libVsId].Variables[template.Id];
                }
            }

            return null;
        };

        var results = libraryTemplates.map(function (template) {
            return tenants.map(function (tenant) {
                var value = getTenantsValue(tenant, template) || template.DefaultValue;
                return {
                    State: value ? stateOk : {
                        icon: "warning",
                        class: "text-warning",
                        title: "This variable is missing for this tenant"
                    },
                    Name: template.Name,
                    Id: template.Id + tenant.Id,
                    Value: value,
                    Scope: {Tenant: [tenant.Id]},
                    IsSensitive: isSensitive(template, value),
                    Source: {link: "/tenants/" + tenant.Id + "/variables", name: tenant.Name}
                };
            });
        });
        return _.flatten(results);
    }

    function isSensitive(template, value) {
        return template.DisplaySettings["Octopus.ControlType"] === "Sensitive" && !!value && value.HasValue ;
    }

    function toHash(array, keyName, valueName) {
        var values = valueName ? _.pluck(array, valueName) : array;
        return _.object(_.pluck(array, keyName), values);
    }


    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/project_variables_all.js
// module id = 575
// module chunks = 1